import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";

import AbEnvironment from "../auth/AbEnvironment";


const abEnvironment = new AbEnvironment();
const mutation = graphql`
mutation FormCreateMutation($input: CreateFormTInput!) {
  createFormT(input: $input) {
    formT {
      formId
      accountId
      description
      formName
      formTitle
      formSubtitle
      created
      createdBy
      updated
      updatedBy
    }
  }
}
`;

function commit(accountId, formName, formTitle, formSubtitle, description) {
  var variables = {
    input: {
      formT: {
        accountId: accountId,
        formName: formName,
        formTitle: formTitle,
        description: description
      }
    }
  };

  if (formSubtitle != null && formSubtitle.length > 0) {
    variables.input.formT.formSubtitle = formSubtitle;
  }

  //the function to run on promise
  return new Promise((resolve, reject) => {

    
    commitMutation(abEnvironment.getEnvironment(), {
        mutation,
        variables,
        onCompleted: response => {
          resolve(response);
        },
        onError: error => {
          reject(error);
        }
      });
  });
}

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { commit };